/**
 * Take a match model from either CFS or a Pulse API and model it to work in the
 * Match Card component.
 *
 * @param {object} match A match model from either the CFS or pulse apis
 * @returns {object} The formatted match model
 */
export function useMatchModel(match) {
    // Pulselive API Match model
    if (match?.id) {
        return {
            home: {
                abbr: PULSE.app.common.team.getTeamAbbr(
                    match.home.team.providerId
                ),
                name: match.home.team.name,
                totalScore: match.home?.score?.totalScore,
                teamId: match.home.team.providerId
            },
            away: {
                abbr: PULSE.app.common.team.getTeamAbbr(
                    match.away.team.providerId
                ),
                name: match.away.team.name,
                totalScore: match.away?.score?.totalScore,
                teamId: match.away.team.providerId
            }
        };
        // Else is it a CFS Match model?
    } else if (match?.match) {
        return {
            home: {
                abbr: PULSE.app.common.team.getTeamAbbr(
                    match.match.homeTeam.teamId
                ),
                name: match.match.homeTeam.name,
                teamId: match.match.homeTeam.teamId,
                totalScore: match.score?.homeTeamScore?.matchScore?.totalScore
            },
            away: {
                abbr: PULSE.app.common.team.getTeamAbbr(
                    match.match.awayTeam.teamId
                ),
                name: match.match.awayTeam.name,
                teamId: match.match.awayTeam.teamId,
                totalScore: match.score?.awayTeamScore?.matchScore?.totalScore
            }
        };
    }

    return null;
}
